<template>
  <div>
    <h3>
      <span>
        {{$t('message.script_config_vpn_connection') | title}}
      </span>
      <span class="wiki-link">
        <a :href="$t('message.script_config_vpn_connection_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <div v-if='willRunOnEachClusterNode == true' class='cluster-info'>
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if='willRunOnThisClusterNodeOnly == true' class='cluster-info'>
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <b-form v-if='vpnConfig' enctype="multipart/form-data" align-h="center">
      <b-form-row v-for="(param, paramName) in vpnConfig" v-bind:key="paramName">
        <div v-if="vpnConfig.type.value=='OpenVPN' || param.type=='vpn_type'" class='col-3 label label-default'>
          {{ $t('message.script_config_vpn_connection_' + paramName) | title }}
        </div>
        <div class='col-8'>
          <b-form-select v-if="param.type=='vpn_type'" v-model='param.value'
            :options='vpnTypeOptions' class='form-control' :disabled="!status || status=='connected' || status=='unknown session'"/>
          <b-form-input v-if="vpnConfig.type.value=='OpenVPN' && param.type=='string'"
            v-model="param.value" :disabled="!status || status=='connected' || status=='unknown session'"/>
          <b-form-input v-if="vpnConfig.type.value=='OpenVPN' && param.type=='password'"
            type="password" v-model="param.value"  placeholder="******" :disabled="!status || status=='connected' || status=='unknown session'"/>
          <div class="form-group form-check">
            <input type="checkbox" v-if="vpnConfig.type.value=='OpenVPN'&& paramName=='autoconnect'"
              class="form-check-input" v-model="param.value" @change="OnAutoconnectChange"/>
          </div>
          <b-form-file v-if="vpnConfig.type.value=='OpenVPN' && param.type=='upload'" v-model="param.value"
            :state="Boolean(param.value)" placeholder="Choose a file..." accept=".ovpn" :disabled="!status || status=='connected' || status=='unknown session'"/>
        </div>
      </b-form-row>

      <b-alert v-model="showError" variant="danger" dismissible @dismissed="error=''; showError=false;">
        <div v-html="error"> </div>
        <div v-if="errorRemark"> {{ errorRemark }}</div>
      </b-alert>

      <b-button class='padmin-button submit-button' @click='save' :disabled='buttonsDisabled'>
        <b-spinner v-if='saveInProgress' small type='grow'/>
        {{$t('message.button_save') | title}}
      </b-button>

    </b-form>

    <div v-if="status">
      Status: <span id="status-display">{{statusDisplay}}</span>
    </div>
    <b-row id="status-part">
      <div class="col-8">
        <b-form-textarea v-if="statusOutput" v-model="statusOutput" plaintext disabled rows="10" no-resize/>
      </div>

      <div class="col-2">
        <b-button v-if="status!='not configured'"
          class='padmin-button' @click="runCommand('status')" :disabled='buttonsDisabled'>
          <b-spinner v-if="commandInProgress=='status'" small type='grow'/>
          {{$t('message.button_status') | title}}
        </b-button>
        <b-button v-if="status=='not_connected'" class='padmin-button submit-button'
          @click="runCommand('connect')" :disabled='buttonsDisabled'>
          <b-spinner v-if="commandInProgress=='connect'" small type='grow'/>
          {{$t('message.button_connect') | title}}
        </b-button>
        <b-button v-if="status=='connected' || status=='unknown' || status=='unknown_session'"
          class='padmin-button submit-button' @click="runCommand('disconnect')" :disabled='buttonsDisabled'>
          <b-spinner v-if="commandInProgress=='disconnect'" small type='grow'/>
          {{$t('message.button_disconnect') | title}}
        </b-button>
      </div>
    </b-row>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

  </div>
</template>

<script>
import { get, post } from '../http'
import ConsoleOutput from "./ConsoleOutput";

export default {
  name: 'VpnConnection',

  components: {
    ConsoleOutput
  },

  data() {
    return {
      vpnConfig: null,
      vpnTypeOptions: [{text: '----------', value: null}, {text: 'OpenVPN', value: 'OpenVPN'}],
      saveInProgress: false,
      commandInProgress: null,
      showError: null,
      result: null,
      output: null,
      status: null,
      statusOutput: null
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    buttonsDisabled() {
      return this.saveInProgress || this.commandInProgress
    },

    statusDisplay() {
      if (!this.status) {
        return ''
      }
      console.log(this.status, this.$t('message.vpn_status_' + this.status))
      return this.$t('message.vpn_status_' + this.status).toUpperCase()
    }
  },

  methods: {
    getVpnConfigUrl() {
      return ('/scripts/config/vpn_connection')
    },

    getVpnCommandUrl() {
      return ('/vpn_command')
    },

    load() {
      this.runCommand('status')
      get(this.getVpnConfigUrl()).then(
        resp => {
          this.vpnConfig = resp.data['params']
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
        },
        err => {
          console.log('err', err)
        })
    },

    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },

    runCommand(command) {
      const formData = new FormData()
      formData.append('command', command)

      this.result = null
      this.status = null
      this.output = ''
      this.statusOutput = ''
      this.commandInProgress = command

      post(this.getVpnCommandUrl(), formData, {"content-type": "multipart/form-data"}).then(
        resp => {
          this.result = resp.data.result
          if (command == 'status') {
            this.statusOutput = resp.data.output
            this.status = resp.data.status
            this.commandInProgress = null
          } else {
            this.output = resp.data.output
            this.delay(4000).then(() => this.runCommand('status'))
          }
        },
        err => {
          this.commandInProgress = null
          console.log(err)
        }
      )
    },

    save() {
      this.result = null
      this.output = ''

      if (!this.vpnConfig['type'].value) {
        this.vpnConfig['username'].value = ''
        this.vpnConfig['password'].value = ''
        this.vpnConfig['autoconnect'].value = false
        this.vpnConfig['vpn_profile'].value = null

      }

      const formData = new FormData()
      for (let field in this.vpnConfig) {
        let param = this.vpnConfig[field]
        if (param.value && param.value.name) {
          let ext = param.value.name.split('.').pop()
          if (param.type == 'upload') {
            if (ext != 'ovpn') {
              this.error = this.$t('message.error_invalid_file_format')
              this.showError = true
              return
            }
          }}
        else if (param.type == 'bool' && (param.value == "null" || param.value == null || param.value == undefined)) {
          param.value = false
        }
        formData.append(field, param.value)
      }

      this.saveInProgress = true
      post(this.getVpnConfigUrl(), formData, {"content-type": "multipart/form-data"}).then(
        resp => {
          this.saveInProgress = false
          this.output = resp.data.output
          this.result = resp.data.result
          if (resp.data.error) {
            this.showError = true
            this.error = this.$t('message.error_' + resp.data.error)
          } else {
            this.error = null
            this.showError = false
            this.runCommand('status')
          }
        },
        err => {
          this.saveInProgress = false
          console.log(err)
        }
      )
    },

    OnAutoconnectChange(newVal) {
      if (newVal && this.status != 'connected') {
        this.vpnConfig.autoconnect.value = false
        this.error = this.$t('message.error_vpn_enable_autoconnect_in_connected_state_only')
        this.showError = true
      }
    }
  }
}
</script>
<style>
#status-part {
  margin-left: 50px;
}
#status-display {
  font-weight: 800;
}
</style>
